var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVilla(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 1.34944C12.3061 0.989396 11.6938 0.989396 11.2855 1.34944L0.388463 10.9607C0.156925 11.1649 0.0238539 11.4584 0.0228593 11.7671L0.00342369 17.8003C0.00149781 18.3981 0.485591 18.8837 1.08342 18.8837H8.0081V17.4503C8.0081 15.5103 9.79585 13.9367 11.9999 13.9367C14.204 13.9367 15.9918 15.5103 15.9918 17.4503V18.8837H22.9164C23.5143 18.8837 23.9984 18.3981 23.9964 17.8003L23.977 11.7671C23.976 11.4584 23.8429 11.1649 23.6114 10.9607L12.7143 1.34944Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2856 0.269789C11.6938 -0.0902553 12.3062 -0.0902551 12.7144 0.269789L23.6112 9.88082C23.8429 10.0851 23.976 10.3789 23.9769 10.6878L23.997 17.9211C23.9986 18.5187 23.5146 19.0041 22.917 19.0041H15.9918V16.3707C15.9918 14.4306 14.2041 12.8571 12 12.8571C9.79591 12.8571 8.00816 14.4306 8.00816 16.3707V19.0041H1.083C0.485361 19.0041 0.00134359 18.5187 0.0030064 17.9211L0.0231316 10.6878C0.0239911 10.3789 0.157075 10.0851 0.388737 9.88082L11.2856 0.269789ZM1.296 21.156C0.580239 21.156 0 21.7362 0 22.452V22.7115C0 23.4273 0.580238 24.0075 1.296 24.0075H22.704C23.4198 24.0075 24 23.4273 24 22.7115V22.452C24 21.7362 23.4198 21.156 22.704 21.156H1.296Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVilla);
export default __webpack_public_path__ + "static/media/Villa.1fc4c8e9846633bceade9120c15010ce.svg";
export { ForwardRef as ReactComponent };